// API configuration.
// The app calls the API on its own origin under `/api`; the Vite dev server (and
// the production proxy) forwards those requests to the backend with the prefix
// stripped. Same-origin keeps the HttpOnly session cookie first-party.
export const API_BASE_URL = '/api';
